<template>
  <h1 v-if="content !== null" style="display: none;">{{ decodeHtml(content.text) }}</h1>
</template>

<script>
import { decodeHtml } from '@/utils/string'; // Import decodeHtml utility

export default {
  name: 'HeadingContent',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  methods: {
    decodeHtml
  }
}
</script>

<style scoped>
/* Add styles for heading content if needed */
</style>
